<template>
  <div class="aside-menu-component">
    <div v-if="currentStep === 2" v-show="!collapsed" class="menu-middle">
      <v-btn-toggle
        v-model="localCategory"
        dense
        group
        mandatory
      >
        <v-row>
          <v-col
            v-for="(category, i) in categoriesList"
            :key="i"
            :sm="i === 0 || i === 1 || category.onlyCrm ? 12 : 6"
          >
            <v-btn
              :value="category.id"
              class="button-menu"
              block
              light
              :disabled="currentStep === 0"
              @click="changeCategory(category.id)"
            >
              {{ category.name }}
            </v-btn>
          </v-col>
        </v-row>
      </v-btn-toggle>
    </div>

    <div v-if="[1,3].includes(currentStep)" v-show="!collapsed" class="address-menu">
      <!--      <div class="button-section">
        <v-btn-toggle
          v-model="localSecondStepWindow"
          dense
          group
          mandatory
          class="d-block"
        >
          <v-row>
            <v-col sm="12">
              <v-btn value="address" class="button-menu" block light>
                Адрес
                <transition name="fadeUp">
                  <span v-if="basketDeliveryValid" class="checkmark">
                    <font-awesome-icon icon="check" />
                  </span>
                </transition>
              </v-btn>
            </v-col>
            <v-col sm="12">
              <v-btn
                value="payment"
                :disabled="!basketDeliveryValid"
                class="button-menu" block light
              >
                Оплата
                <transition name="fadeUp">
                  <span v-if="basket.paymentType" class="checkmark">
                    <font-awesome-icon icon="check" />
                  </span>
                </transition>
              </v-btn>
            </v-col>
          </v-row>
        </v-btn-toggle>
      </div>-->

      <div class="commentary">
        <span class="label font-weight-medium"> Комментарий для курьера </span>
        <v-textarea
          v-model="comment"
          color="#000000"
          placeholder="Введите комментарий"
          class="textarea"
          solo
          flat
          no-resize
          hide-details="auto"
          @focus="showKeyboard"
        />
      </div>
    </div>

    <div class="menu-bottom" :class="{ 'menu-bottom--collapsed': collapsed }">
      <!-- Компактный десктоп: окна заказа перенесены сюда из правой панели -->
      <div v-if="showOrderWindows" class="order-windows">
        <v-btn
          v-for="item in orderWindows"
          :key="item.window"
          class="button-menu button-window"
          :class="{ active: isOrderWindowActive(item.window) }"
          light
          :disabled="isOrderWindowDisabled(item.window)"
          :title="item.title"
          @click="openOtherWindow(item.window)"
        >
          <font-awesome-icon v-if="item.icon" :icon="item.icon" />
          <template v-else>
            {{ item.label }}
          </template>
        </v-btn>
      </div>
      <v-btn
        v-show="!collapsed"
        class="button-promotions"
        :class="{ active: showPromotionsWindow }"
        :disabled="currentStep === 0 || !basket.filial || isOrderPaid"
        block
        light
        @click="togglePromotionsWindow"
      >
        <font-awesome-icon icon="percent" />
        Акции
      </v-btn>
      <v-row>
        <!--        <v-col v-for="(item, i) in bottomItems" :key="i" sm="4">
          <div>
            <v-btn
              class="button-menu"
              :class="{active: currentOtherWindow === item.window}"
              light
              width="100%"
              :disabled="currentStep === 0"
              @click="openOtherWindow(item.window)"
            >
              {{ item.title }}
            </v-btn>
          </div>
        </v-col>-->
        <v-col v-show="!collapsed" sm="4">
          <v-btn
            class="button-menu"
            :class="{active: currentOtherWindow === '-'}"
            light
            width="100%"
            :disabled="true"
            @click="openOtherWindow('-')"
          >
          </v-btn>
        </v-col>
        <v-col :sm="collapsed ? 12 : 4">
          <v-btn
            class="button-menu button-client"
            :class="{active: currentOtherWindow === 'history'}"
            light
            width="100%"
            :disabled="currentStep === 0 || isClientAnonymous"
            :title="collapsed ? 'Карточка клиента' : undefined"
            @click="openOtherWindow('history')"
          >
            {{ collapsed ? 'К' : 'Клиент' }}
          </v-btn>
        </v-col>
        <v-col v-show="!collapsed" sm="4">
          <v-btn
            class="button-menu"
            :class="{active: currentOtherWindow === '-'}"
            light
            width="100%"
            disabled
            @click="openOtherWindow('-')"
          >
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import orderMenuCategories from '@/mixins/order-menu-categories'

  export default {
    name: 'Menu',
    mixins: [mixinSnackbarMessage, orderMenuCategories],
    props: {
      // сайдбар свёрнут в полоску - от меню остаётся кнопка карточки клиента
      collapsed: {
        type: Boolean,
        default: false,
      },
      // компактный десктоп (в полоске и в развёрнутом виде)
      compact: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        courierInputTimeout: null,
        bottomItems: [
          { title: '  ', window: '-' },
          { title: 'Клиент', window: 'history' },
          { title: '  ', window: '-' },
        ],
        // те же окна и в том же порядке, что были в правой панели заказа
        orderWindows: [
          { window: 'modifications', label: 'М', title: 'Модификаторы' },
          { window: 'commentaries', icon: 'comment-dots', title: 'Комментарии' },
          { window: 'preorder', icon: 'clock', title: 'Предзаказ' },
        ],
      }
    },
    watch: {
      'basket.commentForCourier' () {
        this.$store.commit(this.orderEditPrefix + '/setCourierComment', this.basket.commentForCourier)
      },
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
        newOrder: state => state.newOrder,
        fastOrder: state => state.fastOrder,
      }),
      ...mapGetters({
        basketDeliveryValid: 'baskets/basketDeliveryValid',
        isOrderPaid: 'orders/isOrderPaid',
      }),
      isNewOrderPage () {
        return this.$route.name === 'newOrder'
      },
      order () {
        return this.isNewOrderPage ? this.newOrder : this.fastOrder
      },
      orderEditPrefix () {
        return this.isNewOrderPage ? 'newOrder' : 'fastOrder'
      },
      isClientAnonymous () {
        return !this.basket.client?.phone
      },
      // Только на странице нового заказа: там эти кнопки убраны из правой панели.
      // На редактировании заказа они остались справа - дублировать не нужно
      showOrderWindows () {
        return this.compact && this.isNewOrderPage
      },
      hasPreorder () {
        return !!this.basket.dateDelivery
      },
      currentStep () { return this.order.currentStep },
      showPromotionsWindow () { return this.order.showPromotionsWindow },
      currentOtherWindow () { return this.order.currentOtherWindow },
      comment: {
        get () {
          return this.order.courierComment
        },
        set (value) {
          this.updateBasketComment(value)
        },
      },
      localSecondStepWindow: {
        get () {
          return this.order.secondStepWindow
        },
        set (value) {
          this.$store.commit(this.orderEditPrefix + '/setSecondStepWindow', value)
        },
      },
    },
    methods: {
      // у предзаказа кнопка подсвечена и когда окно закрыто, но дата уже выбрана
      isOrderWindowActive (window) {
        return this.currentOtherWindow === window || (window === 'preorder' && this.hasPreorder)
      },
      isOrderWindowDisabled (window) {
        return this.currentStep === 0 || (window === 'preorder' && !this.basket.filialId)
      },
      openOtherWindow (window) {
        if (!window) return
        if (this.currentOtherWindow === window) {
          this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
        } else {
          this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', window)
          this.$store.commit(this.orderEditPrefix + '/togglePromotionsWindow', false)
        }
      },
      showKeyboard () {
        this.$store.commit(this.orderEditPrefix + '/toggleCommentKeyboard', true)
      },
      updateBasketComment (value) {
        this.$store.commit(this.orderEditPrefix + '/setCourierComment', value)
        const data = {
          commentForCourier: this.comment,
        }
        const id = this.basket.id
        clearTimeout(this.courierInputTimeout)
        this.courierInputTimeout = setTimeout(() => {
          this.$store
            .dispatch('baskets/updateBasket', { data, id })
            .then((res) => {
              if (res.status === 200) {
                this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
                this.showSuccessMessage('Комментарий обновлен')
              } else {
                this.showErrorMessage(res.response.data.message)
              }
            })
        }, 1500)
      },
      togglePromotionsWindow () {
        this.$store.commit(
          this.orderEditPrefix + '/togglePromotionsWindow',
          !this.showPromotionsWindow,
        )
        this.$store.commit(this.orderEditPrefix + '/setCurrentOtherWindow', undefined)
      },
    },
  }
</script>

<style lang="less" scoped>
.aside-menu-component {
  padding-bottom: 25px;

  .button-menu {
    height: 5.7em !important;
    font-size: 1em;
    line-height: 18px;

    &.active {
      background-color: #ff9100 !important;
      color: #fff !important;
    }

    .checkmark {
      position: absolute;
      right: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      width: 27px;
      height: 27px;
      background-color: @color-success;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  ::v-deep {
    .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: @color-secondary !important;
    }
  }

  .menu-top {
    .button-menu {
      margin-bottom: 10px;
    }
  }

  .menu-middle {
    margin-bottom: 46px;

    .button-menu {
      max-width: 100%;
      height: 4.7em !important;
      // длинное название категории («Салаты и закуски») не помещается в кнопку
      // на полширины - переносим на вторую строку
      padding: 0 8px !important;

      ::v-deep {
        &:before {
          display: none;
        }

        .v-btn__content {
          flex: 1 1 auto;
          max-width: 100%;
          white-space: normal;
          text-align: center;
          line-height: 1.2;
        }
      }
    }

    ::v-deep {
      &.v-item--active {
        color: #ffffff;
        background-color: @color-primary !important;

        &:before {
          display: none;
        }
      }
    }

    .row {
      margin: -10px;

      .col {
        padding: 5px;
      }
    }
  }

  .address-menu {
    margin-bottom: 57px;

    .label {
      color: #ffffff;
    }

    .button-section {
      margin-bottom: 40px;

      .media-xl({
        margin-bottom: 98px;
      });

      ::v-deep {
        .button-menu {
          &.v-item--active {
            color: #ffffff;
            background-color: @color-primary !important;

            &:before {
              display: none;
            }
          }
        }
      }
    }

    .commentary {
      .textarea {
        ::v-deep {
          .v-input__slot {
            background-color: #ffffff;

            textarea {
              color: #000000;

              &::placeholder {
                color: #000000;
              }
            }
          }
        }
      }
    }
  }

  .menu-bottom {
    .button-menu {
      height: 4em !important;
    }

    ::v-deep {
      .v-btn:not(.v-btn--round).v-size--default {
        min-width: 50px;
      }
    }

    .row {
      margin: -8px;

      .col {
        padding: 8px;

        &:nth-child(even) {
          padding: 8px 0 8px 0;
        }
      }
    }

    // Окна заказа в развёрнутой панели - ряд из трёх кнопок над «Акциями».
    // Ширины и зазоры как у нижнего ряда с «Клиент»: там три колонки по трети
    // ряда, у крайних поля по 8px - отсюда узкие крайние кнопки и широкая средняя
    .order-windows {
      display: flex;
      gap: 8px;
      margin-bottom: 10px;

      // высота в px: у кнопок меню она задана в em, а шрифт здесь свой
      .button-window {
        flex: 0 0 ~"calc((100% + 16px) / 3 - 16px)";
        min-width: 0 !important;

        &:nth-child(2) {
          flex: 1 1 auto;
        }

        height: 48px !important;
        font-size: 20px;
        font-weight: 500;

        svg {
          font-size: 20px;
          height: 1em;
        }

        &.active svg {
          ::v-deep {
            .fill-svg(#ffffff);
          }
        }
      }
    }

    // Полоска: столбик кнопок 52x52 - окна заказа и «К», карточка клиента.
    // Скругление 10px, как у кнопки разворачивания; в развёрнутой панели - обычное
    &--collapsed {
      .row .col,
      .row .col:nth-child(even) {
        padding: 8px;
      }

      .button-menu {
        border-radius: 10px;
      }

      .order-windows {
        flex-direction: column;
        gap: 14px;
        margin-bottom: 14px;

        .button-window,
        .button-window:nth-child(2) {
          flex: 0 0 auto;
          height: 52px !important;
          font-size: 26px;

          svg {
            font-size: 24px;
          }
        }
      }

      .button-client {
        height: 52px !important;
        font-size: 26px;
        font-weight: 500;
      }
    }

    .button-promotions {
      font-size: 1em;
      line-height: 1.3;
      margin-bottom: 10px;
      height: 4em !important;
      //background-color: #0033ff !important;
      background-color: #fff !important;

      &.active {
        background-color: @color-primary !important;
        color: #ffffff !important;
      }

      svg {
        margin-right: 18px;
      }
    }
  }
}
</style>
